
import React, { createContext, useState, useEffect } from 'react';
import { getUserFollowingOrganizations } from '../services/apiOragnizations';

export const FollowOrganizationContext = createContext();

export const FollowOrganizationProvider = ({ children }) => {
  const [followOrganizations, setFollowOragnization] = useState([]);
  

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData?._id) {
      let payload = { userid: userData._id };
      fetchAllOragnizations(payload);
    }
  }, []);



  const fetchAllOragnizations = async (payload) => {
   try {
      let listOrganizations = await getUserFollowingOrganizations(payload);
      setFollowOragnization(listOrganizations?.organizations || []);
    } catch (error) {
      console.error("Failed to fetch organizations", error);
    }
  };


  return (
    <FollowOrganizationContext.Provider value={{ followOrganizations, fetchAllOragnizations }}>
      {children}
    </FollowOrganizationContext.Provider>
  );
};
